export const validateMultiRolesAndPermissions = (res) => {
  
  let tabs = [];
  if(res){
    const listOfRole = res?.data;
    const listOfTab = listOfRole.map(e => e.tabs);

    for(let i=0; i < listOfTab.length; i++){
      if(i===0){
        for(let x=0; x < listOfTab[i].length; x++){
          tabs.push(listOfTab[i][x]);
        }          
      }else{
        //check tabs
        for(let y=0; y < listOfTab[i].length; y++){
          const isTabExist = tabs.some(e => e.name === listOfTab[i][y].name);
          if(isTabExist){
            //check fields
            const existFeilds = tabs.filter(e => e.name === listOfTab[i][y].name)[0].fields;
            const newFeilds = removeDuplicatesAndKeepTrueEditFeilds(existFeilds, listOfTab[i][y].fields);

            //check permissions
            const existPermissions = tabs.filter(e => e.name === listOfTab[i][y].name)[0].permissions;
            const newPermissions = removeDuplicatesAndKeepTrueValuePermissions(existPermissions, listOfTab[i][y].permissions); 

            tabs = tabs.map(obj => {
              if (obj.name === listOfTab[i][y].name) {
                  return { ...obj, fields: newFeilds, permissions: newPermissions };
              }
              return obj;
            });

          }else{
            tabs.push(listOfTab[i][y]);
          }
        }  
      }
    }
  }

  return tabs;
}

const removeDuplicatesAndKeepTrueEditFeilds = (array1, array2) => {
  const map = new Map();

  // Add elements from array1 to the map
  array1.forEach(obj => {
      const key = obj.name + obj.category;
      if (!map.has(key)) {
          map.set(key, obj);
      }
  });

  // Add elements from array2 to the map
  array2.forEach(obj => {
      const key = obj.name + obj.category;
      if (!map.has(key) || (map.get(key).edit === false && obj.edit === true) || (map.get(key).view === false && obj.view === true)) {
          map.set(key, obj);
      }
  });

  // Extract values from the map to get unique objects
  return Array.from(map.values());
}


const removeDuplicatesAndKeepTrueValuePermissions = (array1, array2) => {
  const map = new Map();

  // Add elements from array1 to the map
  array1.forEach(obj => {
      map.set(obj.name, obj);
  });

  // Add elements from array2 to the map
  array2.forEach(obj => {
      if (!map.has(obj.name) || (map.get(obj.name).value === false && obj.value === true)) {
          map.set(obj.name, obj);
      }
  });

  // Extract values from the map to get unique objects
  return Array.from(map.values());
}


export const compareObjects = (obj1, obj2, excludedProperty) => {
  // Get the keys of the objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Iterate over the keys and compare the values
  for (let key of keys1) {
    // Skip the excluded property
    if (key === excludedProperty) {
      continue;
    }

    // Check if the values are not equal
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  // If all checks passed, the objects are equal
  return true;
}